import React, { useState, useEffect } from "react";
import { InfluencerCardInvoiceContainer } from "./InfluencerCardInvoiceStyled";
import avatar from './../../utils/images/avatar_fluincr.png';
import { formatNumber, toUpperCase } from "../../services/generalSevices";
import { useNavigate } from 'react-router-dom';
import { useContext } from "react";
import { UserContext } from "../../context/userContext";
import { lowerFare3 } from "../../services/generalSevices";
import LikeInfluencer from "../LikeInfluencer/LikeInfluencer";
import { getConvertCurrency } from "../../api/exchangeApi";
import { CurrencyContext } from "../../context/currencyContext";
import { LangContext } from "../../context/langContext";

export default function InfluencerCardInvoice({ influencer, page }) {

    const { locale } = useContext(LangContext);
    const [isFavorite, setIsFavorite] = useState(false);
    const navigate = useNavigate();

    const { userToken, userType } = useContext(UserContext);
    const { currency } = useContext(CurrencyContext);

    const [price, setPrice] = useState(null);

    /* const handlerLike = () => {
        if (userToken === null) {
            navigate('/signin')
        } else {
            setIsFavorite(!isFavorite)
        }
    } */
    useEffect(() => {
        const amount = lowerFare3((influencer.price !== null) ? (influencer.price) : [0]);
        const auxCurrency = currency.symbol;
        getConvertCurrency({ amount: amount }).then((response) => {
            //setPrice(response[auxCurrency].toFixed(0))
            setPrice(response[auxCurrency].toFixed(2))
        })
    }, [currency])

    return (
        <InfluencerCardInvoiceContainer page={page} >

            <div className="image" style={{ backgroundImage: `url(${(influencer.image_profile !== null) ? influencer.image_profile : avatar})` }} >

                {/*  {(userType === 'company' || userToken === null) ? (<img src={(isFavorite) ? colorStar : whiteStar} alt="favorite" className="favorite" onClick={handlerLike} />) : (<div className="favorite" />)} */}

                <div className="favoriteContainer">
                    {(userType === 'company' || userToken === null) ? (<LikeInfluencer profileId={influencer.id} isFavorite={isFavorite} setIsFavorite={setIsFavorite} />) : (<div className="favorite" />)}
                </div>

                <div className="data">
                    <p><span className="currencySymbol">{currency.symbol}</span> {formatNumber(price)}</p>
                    {/* <p>1.1 M</p> */}
                </div>
            </div>

            <h3 className="name" onClick={() => {
                navigate(`/${influencer.username}`)
            }}>{(toUpperCase({ fullName: `${influencer.name?.split(' ')[0]} ${(influencer.name?.split(' ')[1])}` }))}</h3>

            <div className="influencerData">
                <img src={influencer?.imagecountry} alt="" className="influencerCountry" />
                <div className="categories">
                    {/* {influencer?.namecategory?.map((category, index) => {
                        if (index < 2) {
                            return (
                                <span className="category">#{category}</span>
                            )
                        }

                    })} */}
                    {(locale === 'es-CO') ? (influencer?.nombrecategory?.map((category, index) => {
                        if (index < 2) {
                            return (
                                <span className="category">#{category}</span>
                            )
                        }

                    })) : (influencer?.namecategory?.map((category, index) => {
                        if (index < 2) {
                            return (
                                <span className="category">#{category}</span>
                            )
                        }

                    }))}
                </div>
            </div>
        </InfluencerCardInvoiceContainer>
    )
}